import axios from "axios";

// export const BaseUrl = axios.create({
//   baseURL: `http://localhost:8080/my_Leads/`,
// });

export const BaseUrl = axios.create({
  baseURL: `https://myleadsapi.bridgebrilliance.com/my_Leads/`,
});
